webpackJsonp([13396140415750],{

/***/ 113:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Buttons = function Buttons(_ref) {
	  var sc = _ref.sc;
	  return _react2.default.createElement(
	    'ul',
	    null,
	    _react2.default.createElement(
	      'li',
	      null,
	      ' ',
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary', onClick: function onClick(e) {
	            sc.gen('staked');
	          } },
	        ' Staked '
	      ),
	      ' '
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      ' ',
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-secondary', onClick: function onClick(e) {
	            sc.gen('un-staked');
	          } },
	        ' Un-staked '
	      ),
	      ' '
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      ' ',
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-success', onClick: function onClick(e) {
	            sc.gen('chopped-up');
	          } },
	        ' Chopped Up '
	      ),
	      ' '
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      ' ',
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-info', onClick: function onClick(e) {
	            sc.gen('healed');
	          } },
	        ' Healed '
	      ),
	      ' '
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      ' ',
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-danger', onClick: function onClick(e) {
	            sc.gen('burned');
	          } },
	        ' Burned '
	      ),
	      ' '
	    )
	  );
	};
	
	exports.default = Buttons;
	module.exports = exports['default'];

/***/ }),

/***/ 900:
/***/ (function(module, exports) {

	module.exports = "import React from 'react'\n\nconst Buttons = ({sc}) => (\n  <ul>\n    <li> <button className=\"btn btn-primary\" onClick={(e) => {sc.gen('staked')}}> Staked </button> </li>\n    <li> <button className=\"btn btn-secondary\" onClick={(e) => {sc.gen('un-staked')}}> Un-staked </button> </li>\n    <li> <button className=\"btn btn-success\" onClick={(e) => {sc.gen('chopped-up')}}> Chopped Up </button> </li>\n    <li> <button className=\"btn btn-info\" onClick={(e) => {sc.gen('healed')}}> Healed </button> </li>\n    <li> <button className=\"btn btn-danger\" onClick={(e) => {sc.gen('burned')}}> Burned </button> </li>\n  </ul>\n)\n\nexport default Buttons; \n"

/***/ }),

/***/ 1013:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dead.b559c949.png";

/***/ }),

/***/ 1014:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/disabled.8ec3b75f.png";

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.VampireExample = exports.vampireScxml = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _scxml = __webpack_require__(28);
	
	var _scxml2 = _interopRequireDefault(_scxml);
	
	var _vampire = __webpack_require__(902);
	
	var _vampire2 = _interopRequireDefault(_vampire);
	
	var _components = __webpack_require__(68);
	
	var _vampireImage = __webpack_require__(405);
	
	var _vampireImage2 = _interopRequireDefault(_vampireImage);
	
	var _vampireImage3 = __webpack_require__(901);
	
	var _vampireImage4 = _interopRequireDefault(_vampireImage3);
	
	var _buttons = __webpack_require__(403);
	
	var _buttons2 = _interopRequireDefault(_buttons);
	
	var _buttonsTxt = __webpack_require__(900);
	
	var _buttonsTxt2 = _interopRequireDefault(_buttonsTxt);
	
	var _common = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var vampireScxml = exports.vampireScxml = _vampire2.default;
	
	var VampireExample = exports.VampireExample = function (_SCComponent) {
	  _inherits(VampireExample, _SCComponent);
	
	  function VampireExample(props) {
	    _classCallCheck(this, VampireExample);
	
	    return _possibleConstructorReturn(this, _SCComponent.call(this, props, vampireScxml));
	  }
	
	  VampireExample.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'table',
	        { style: { width: '100%', height: '455px' } },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '227.5px',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: _buttonsTxt2.default,
	              component: _react2.default.createElement(_buttons2.default, { sc: this.sc }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                ' Click a button to send an event '
	              )
	            }),
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '455px',
	              prismLanguage: 'xml',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: _vampire2.default,
	              component: _react2.default.createElement(_schviz2.default, {
	                scxmlDocumentString: _vampire2.default,
	                disableAnimation: true,
	                configuration: this.state && this.state.configuration,
	                disableZoomAnimation: true,
	                expandAllStatesByDefault: true,
	                transitionsEnabled: this.state && this.state.transitionsEnabled,
	                id: 'vampire2'
	              }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                'Visualization of the running state machine'
	              ),
	              rowSpan: '2'
	            })
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '227.5px',
	              sourceCode: _vampireImage4.default,
	              showSourceCode: this.state.showSourceCode,
	              component: _react2.default.createElement(_vampireImage2.default, { configuration: this.state.configuration }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                'Picture of the vampire\'s current state'
	              )
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'table',
	        { style: { width: '100%' } },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'p',
	                {
	                  onClick: function onClick() {
	                    return _this2.sc.start();
	                  },
	                  style: { color: 'blue', cursor: 'pointer', fontStyle: 'italic' } },
	                _react2.default.createElement('i', { className: 'fas fa-redo' }),
	                ' Click to reset the state machine'
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(_components.ShowHideSourceCodeLink, { self: this })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return VampireExample;
	}(_common.SCComponent);

/***/ }),

/***/ 1015:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/intact.a668a1ea.png";

/***/ }),

/***/ 1016:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/torpor.0e182cc8.png";

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dead = __webpack_require__(1013);
	
	var _dead2 = _interopRequireDefault(_dead);
	
	var _disabled = __webpack_require__(1014);
	
	var _disabled2 = _interopRequireDefault(_disabled);
	
	var _intact = __webpack_require__(1015);
	
	var _intact2 = _interopRequireDefault(_intact);
	
	var _torpor = __webpack_require__(1016);
	
	var _torpor2 = _interopRequireDefault(_torpor);
	
	__webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VampireImg = function VampireImg(_ref) {
	  var configuration = _ref.configuration;
	  return _react2.default.createElement('div', {
	    className: 'fill-image',
	    style: {
	      backgroundImage: 'url(' + function () {
	        switch (configuration && configuration[0]) {
	          case 'dead':
	            return _dead2.default;
	          case 'disabled':
	            return _disabled2.default;
	          case 'intact':
	            return _intact2.default;
	          case 'torpor':
	            return _torpor2.default;
	          default:
	            return '';
	        }
	      }() + ')'
	    } });
	};
	
	exports.default = VampireImg;
	module.exports = exports['default'];

/***/ }),

/***/ 901:
/***/ (function(module, exports) {

	module.exports = "import React from 'react'\nimport dead from './dead.png';\nimport disabled from './disabled.png';\nimport intact from './intact.png';\nimport torpor from './torpor.png';\nimport '../common.css';\n\nconst VampireImg = ({configuration}) => (\n  <div \n    className=\"fill-image\"\n    style={{\n      backgroundImage:`url(${\n        (() => {\n          switch(configuration && configuration[0]){\n            case 'dead': return dead;\n            case 'disabled': return disabled;\n            case 'intact': return intact;\n            case 'torpor': return torpor;\n            default: return '';\n          }\n        })()\n      })`\n    }}/>\n)\n\nexport default VampireImg; \n"

/***/ }),

/***/ 902:
/***/ (function(module, exports) {

	module.exports = "<scxml \n  xmlns=\"http://www.w3.org/2005/07/scxml\"\n  version=\"1.0\"\n  initial=\"alive\">\n  <state id=\"alive\">\n    <state id=\"intact\">\n      <transition event=\"chopped-up\" target=\"disabled\"/>\n      <transition event=\"staked\" target=\"torpor\"/>\n    </state>\n    <state id=\"disabled\">\n      <transition event=\"healed\" target=\"intact\"/>\n    </state>\n    <state id=\"torpor\">\n      <transition event=\"un-staked\" target=\"intact\"/>\n    </state>\n    <transition event=\"burned\" target=\"dead\"/>\n  </state>\n  <final id=\"dead\"/>\n</scxml>\n"

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _prismjs = __webpack_require__(38);
	
	var _prismjs2 = _interopRequireDefault(_prismjs);
	
	var _reactPrism = __webpack_require__(22);
	
	var _reactPrism2 = _interopRequireDefault(_reactPrism);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _vampireExample = __webpack_require__(404);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Fundamentals = function Fundamentals(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    { className: 'container' },
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'blockquote',
	      null,
	      'States. The final frontier. These are the voyages of an enterprising developer. Her eternal mission: to explore strange new techniques, to seek out better ways to engineer for mental models and new design patterns. To boldly go where a few awesome devs have gone before.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'So you\u2019ve found our poignant guide to SCXML and surely you\u2019re wondering \u201CWhy should I want to go out of my way to use formal state machines?\u201D or something like that. Hopefully this introduction addresses that kind of question.'
	    ),
	    React.createElement(
	      'h2',
	      null,
	      ' An example: Nancy\u2019s RPG '
	    ),
	    React.createElement(
	      'h3',
	      null,
	      ' The problem '
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Nancy Drew is authoring a fantasy RPG, and some of the NPCs are vampires, for example. Vampires are complicated: if they\u2019re alive, you can chop them to smithereens, but eventually they\u2019ll come back; if they\u2019re impaled by a wooden stake, that puts them in torpor; and if they\u2019re alive or in fleshy smithereens or in torpor, and you burn them, they\u2019ll die forever.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'She wonders what the best way to represent those states of being are so that it can also scale. This has to run in the browser, so her options are limited. She likes React, but components\u2019 ',
	      React.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' property is static. For vampires, ',
	      React.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' could have the values ',
	      React.createElement(
	        'code',
	        null,
	        'intact'
	      ),
	      ', ',
	      React.createElement(
	        'code',
	        null,
	        'disabled'
	      ),
	      ', ',
	      React.createElement(
	        'code',
	        null,
	        'torpor'
	      ),
	      ', or ',
	      React.createElement(
	        'code',
	        null,
	        'dead'
	      ),
	      ', though it\u2019s the transitions between those states that are complex. Other agents will be able to change a vampire\u2019s state, but only certain transitions between those states are valid.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Vampire components could have a ',
	      React.createElement(
	        'code',
	        null,
	        'changeState'
	      ),
	      ' method, though for this use-case it becomes a complex dispatcher with one big ',
	      React.createElement(
	        'code',
	        null,
	        'switch'
	      ),
	      ' block full of ',
	      React.createElement(
	        'code',
	        null,
	        'if'
	      ),
	      ' blocks:'
	    ),
	    React.createElement(
	      _reactPrism2.default,
	      { component: 'pre', className: 'language-javascript' },
	      '\nfunction changeState (action) {\n  switch (action) {\n    case DMG_THRESHOLD_STAKED:\n      if(this.state === \'intact\' || this.state === \'disabled\'){\n        this.state.set(\'torpor\');\n      }\n      break;\n    case DMG_THRESHOLD_DISABLED:\n      if(this.state === \'intact\') {\n        this.state.set(\'disabled\');\n      }\n      break;\n    case HEAL_THRESHOLD_FULL:\n      if(this.state === \'disabled\' || this.state === \'torpor\'){\n        this.state.set(\'intact\');\n      }\n      break;\n    case DMG_THRESHOLD_BURNED:\n      if(this.state === \'intact\' || this.state === \'disabled\' || this.state === \'torpor\'){\n        this.state.set(\'dead\');\n      }\n      break;\n  }\n}\n'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'This, Nancy decides, (and for the sake of this tutorial,) is ugly. It won\u2019t scale well if different states are introduced, and in general this pattern doesn\u2019t represent the true, complex nature of a character\u2019s abledness. She certainly doesn\u2019t want to deal with dispatch trees like this when she needs to represent many different types of characters and their diverse states.'
	    ),
	    React.createElement(
	      'h3',
	      null,
	      ' Enter state machines '
	    ),
	    React.createElement(
	      'p',
	      null,
	      'A character\u2019s status in general is more accurately represented by nested categories. Are they alive or dead? If they\u2019re alive, can they move? If not, what will rehabilitate them? What kills an angel? A werewolf? An elf?'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Nancy feels state machines are the best way to represent these conditions. Since state machines interpret statecharts, and those can be represented both visually and in machine-readable SCXML she\u2019ll have an easier time both designing and developing the different types of characters.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Instead of the ugly dispatch tree, the vampires\u2019 conditions are represented by this SCXML document:'
	    ),
	    React.createElement(
	      _reactPrism2.default,
	      { component: 'pre', className: 'language-xml' },
	      _vampireExample.vampireScxml
	    ),
	    React.createElement(
	      'h2',
	      null,
	      'What is SCXML?'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'There are many dialects of state machines out there, and many are proprietary. SCXML is an open standard for state machines by the W3C. It describes an ',
	      React.createElement(
	        'strong',
	        null,
	        'XML application'
	      ),
	      ', which specifies a syntax (a set of rules that define how you write XML code to define the state machine), and a semantics (a set of rules which describes how the state machine should be executed). The SCXML syntax is formalized by an XML schema definition, and the semantics is defined in pseudocode, and formalized by a test suite.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Nancy can use SCION to visualize the above SCXML as a diagram:'
	    ),
	    React.createElement(
	      'div',
	      { style: { height: '400px', width: '100%', position: 'relative' } },
	      React.createElement(_schviz2.default, {
	        expandAllStatesByDefault: true,
	        scxmlDocumentString: _vampireExample.vampireScxml,
	        disableAnimation: true,
	        id: 'vampire'
	      })
	    ),
	    React.createElement(
	      'h2',
	      null,
	      'What is SCION?'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'SCION is a suite of software libraries for working with SCXML in JavaScript. It provides:'
	    ),
	    React.createElement(
	      'ul',
	      null,
	      React.createElement(
	        'li',
	        null,
	        ' runtime for executing state machines '
	      ),
	      React.createElement(
	        'li',
	        null,
	        ' compiler for SCXML '
	      ),
	      React.createElement(
	        'li',
	        null,
	        ' visualization '
	      ),
	      React.createElement(
	        'li',
	        null,
	        ' linter '
	      ),
	      React.createElement(
	        'li',
	        null,
	        ' graphical debugger '
	      ),
	      React.createElement(
	        'li',
	        null,
	        ' other tools and utilities '
	      )
	    ),
	    React.createElement(
	      'p',
	      null,
	      'SCION powers the examples on this site.'
	    ),
	    React.createElement(
	      'h2',
	      null,
	      ' How to run a state machine? '
	    ),
	    React.createElement(
	      'p',
	      null,
	      ' Nancy can create a small environment to run the state machine, with buttons to send events as input, and pictures to illustrate the current state: '
	    ),
	    React.createElement(_vampireExample.VampireExample, null),
	    React.createElement(
	      'p',
	      null,
	      'This, Nancy feels, is more elegant, scalable, and easier to read, talk about, and modify. It\u2019s also event-driven, which gels well with the rest of the RPG which has, so far, been developed around events.'
	    ),
	    React.createElement(
	      'h2',
	      null,
	      ' So what are state machines good for? '
	    ),
	    React.createElement(
	      'p',
	      null,
	      'At this point you\u2019re probably thinking \u201CAlright, state machines work well for Nancy Drew\u2019s problems, but will they work well for mine?\u201D Good question.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Does your application have well-defined, named states? Does it receive events? Does it flow between states in response to those events? Then state machines might be a good solution for you.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      '\u2018State\u2019 is a pretty good name for the phenomena SCXML can describe \u2013 when you\u2019re developing software for discrete objects whose behaviors can be described in discrete groups, and those groups change depending on how the object is acted upon or what the object encounters, then you\u2019re looking at an ideal use-case for statecharts.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Users are themselves complicated and stochastic, but they like it when their appliances and applications operate in simple, clearly defined ways. This applies to many facets of those appliances/applications: the way users interact with them, the way they provide feedback to the user, and the tasks they help the user accomplish.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Here are a set of application domains where state machines are often a good fit:'
	    ),
	    React.createElement(
	      'ul',
	      null,
	      React.createElement(
	        'li',
	        null,
	        ' Embedded Systems (for safety-critical control logic) '
	      ),
	      React.createElement(
	        'li',
	        null,
	        ' Interaction design (as a language for communicating between designers and developers) '
	      ),
	      React.createElement(
	        'li',
	        null,
	        ' Business Workflows (like flow charts) '
	      ),
	      React.createElement(
	        'li',
	        null,
	        ' Customer Service (for defining phone trees, IVRs, chatbots, etc.) '
	      )
	    ),
	    React.createElement(
	      'p',
	      null,
	      'There are many other domains where state machines are useful. If you have an idea, please consider contributing a tutorial to this guide.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'All of that is a pretty abstract description, but you\u2019ll find plenty of examples throughout this guide that should help illustrate how useful state machines can be.'
	    )
	  );
	};
	
	var WrappedFundamentals = function WrappedFundamentals(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: Fundamentals, pathname: location.pathname });
	};
	
	exports.default = WrappedFundamentals;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-fundamentals-js-0c36be92f12e01305704.js